import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteChildrenProps } from 'react-router'
import TeamList from './TeamList'
import { TeamsController } from 'iam/TeamsController'
import NewTeamModal from 'iam/components/NewTeamModal'
import TeamsEmpty from './TeamsEmpty'
import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'
import Team from './Team'
import styles from './TeamsRoot.m.sass'
import { SplitView, SplitViewMain, SplitViewSide } from 'components/SplitView'

interface Props extends RouteChildrenProps<{ teamSlug?: string }> {
  controller: TeamsController
}

/**
 * Teams root screen
 */
export default observer(function TeamsRoot({ controller, match }: Props) {
  const slug = match && match.params && match.params.teamSlug
  const { newTeamVM, teamListVM } = controller

  useEffect(() => {
    if (controller.activate.resolved) {
      controller.viewTeam(slug)
    }
  }, [slug, controller.activate.resolved])

  useEffect(() => {
    controller.activate()
    return () => controller.deactivate()
  }, [controller, match])

  return (
    <>
      <div className={styles.container}>
        {controller.activate.match({
          pending: () => <ContentLoading />,
          rejected: (err: any) => <ContentError error={err} />,
          resolved: () => {
            return (
              <SplitView>
                <SplitViewSide>
                  <TeamList
                    vm={teamListVM}
                    onCreateTeamRequest={newTeamVM.show}
                    showCreateAction={controller.canCreateTeam}
                  />
                </SplitViewSide>
                <SplitViewMain>
                  {controller.teams.length === 0 && (
                    <TeamsEmpty
                      showCreateActions={controller.canCreateTeam}
                      onCreateTeamRequest={newTeamVM.show}
                    />
                  )}
                  {slug &&
                    controller.activate.resolved &&
                    controller.viewTeam.match({
                      pending: () => <ContentLoading />,
                      rejected: (err: any) => <ContentError error={err} />,
                      resolved: (vm) => vm && <Team vm={vm}></Team>,
                    })}
                </SplitViewMain>
              </SplitView>
            )
          },
        })}
      </div>
      <NewTeamModal newTeamVM={newTeamVM} />
    </>
  )
})
